var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"suppliers",attrs:{"items":_vm.suppliers,"item-text":function (item) { return item.name; },"item-value":function (item) { return item; },"value":_vm.value,"label":"供應商","placeholder":"請選擇..."},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07056530","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupplierSelect.vue
// module id = null
// module chunks = 